import React from 'react';

const LargeCheckMarkIcon = () => {
  return (
    <svg
      width='38'
      height='29'
      viewBox='0 0 38 29'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.1884 27.7442C12.9611 28.9715 10.9712 28.9715 9.74392 27.7442L0.966145 18.9664C-0.32252 17.6777 -0.322519 15.5884 0.966146 14.2997C2.25481 13.0111 4.34415 13.0111 5.63281 14.2997L10.5217 19.1886C11.3194 19.9864 12.6128 19.9864 13.4106 19.1886L31.6328 0.966393C32.9215 -0.322272 35.0108 -0.322275 36.2995 0.96639C37.5881 2.25505 37.5881 4.34439 36.2995 5.63306L14.1884 27.7442Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default LargeCheckMarkIcon;
